import moment from "moment";
import store from "./store";
import { Message } from "iview";
import _ from "lodash";

export default {
  getBrandResourcefieldId: (brand, field) => {
    console.log(brand, field)
    if (_.get(brand, `resource_id.${field}`))
      return _.get(brand, `resource_id.${field}`);
    else if (_.get(brand, `network_resource.${field}`))
      return _.get(brand, `network_resource.${field}`);
    else
      return _.get(brand, `global_resource.${field}`);
  },
  validUrl: str => {
    if (!str) return false;

    var urlRegex =
      "^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$";
    var url = new RegExp(urlRegex, "i");
    return str.length < 2083 && url.test(str);
  },
  uuidGenerator: () => {
    let s4 = function() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return (
      s4() +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      "-" +
      s4() +
      s4() +
      s4()
    );
  },
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  validateMobile(mobile) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    return re.test(mobile);
  },
  validatePostalCode(code) {
    var re = new RegExp("^([a-zA-Z0-9 ]+)$");
    return re.test(code);
  },
  getLocation: () => {
    return new Promise(function(resolve, reject) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject(new Error("Geolocation is not supported"));
      }
    });
  },
  setRrulePostDate: (dateSet, time) => {
    let parser = new Date();
    let value = moment(dateSet.toISOString()).format("MM/DD/YYYY");
    let parsedTime =
      parser.getHours() + ":" + parser.getMinutes() + ":" + parser.getSeconds();
    let date = new Date(value + " " + time ? time : parsedTime);

    date = time
      ? new Date(value + " " + time)
      : new Date(value + " " + parsedTime);
    let offset = parser.getTimezoneOffset();
    let mMoment = moment(date).utcOffset(offset);
    let newSetTime = mMoment
      .utc()
      .toString()
      .substr(16, 8)
      .replace(/(:)/g, "");
    let dtStr =
      moment(mMoment.toString())
        .toISOString()
        .replace(/\W+/g, "")
        .slice(0, 9) +
      newSetTime +
      "Z";
    let rruleDateStr = "DTSTART=" + dtStr + ";UNTIL=" + dtStr + ";FREQ=DAILY";
    return rruleDateStr;
  },
  getPermission: () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.permissions.query({ name: "geolocation" }).then(resolve);
      } else {
        reject(new Error("Geolocation is not supported"));
      }
    });
  },
  numFormatterToK: number => {
    var SI_PREFIXES = ["", "K", "M", "G", "T", "P", "E"];
    var tier = (Math.log10(number) / 3) | 0;
    if (tier === 0) return number;

    var prefix = SI_PREFIXES[tier];
    var scale = Math.pow(10, tier * 3);
    var scaled = number / scale;
    console.log(scaled.toFixed(1));
    return scaled.toFixed(1) + prefix;
  },
  triggerShare(url, name, img, desc) {
    FB.ui(
      {
        method: "feed",
        link: url,
        name: name,
        picture: img,
        description: desc
      },
      function(response) {}
    );
  },
  checkMobileOS() {
    var MobileUserAgent =
      navigator.userAgent || navigator.vendor || window.opera;
    if (
      MobileUserAgent.match(/iPad/i) ||
      MobileUserAgent.match(/iPhone/i) ||
      MobileUserAgent.match(/iPod/i)
    ) {
      return "iOS";
    } else if (MobileUserAgent.match(/Android/i)) {
      return "Android";
    } else {
      return "unknown";
    }
  },
  stringContainsUrl(string) {
    let urlCheck = new RegExp(
      "((ftp|http|https|gopher|mailto|news|nntp|telnet|wais|file|prospero|aim|webcal):(([A-Za-z0-9$_.+!*(),;/?:@&~=-])|%[A-Fa-f0-9]{2}){2,}(#([a-zA-Z0-9][a-zA-Z0-9$_.+!*(),;/?:@&~=%-]*))?([A-Za-z0-9$_+!*();/?:~-]))",
      "g"
    );
    let stringContainer = string.match(urlCheck);
    if (stringContainer) {
      let data = { type: null, url: null };
      data.url = stringContainer[0];
      let p = /^(http(s)?:\/\/)?((w){3}.)?(\m.)?youtu(be|.be)?(\.com)?\/.+/gm;
      stringContainer[0].match(p)
        ? (data.type = "video")
        : (data.type = "link");
      return data;
    }

    return false;
  },
  validateYouTubeUrl(url) {
    if (url != undefined || url != "") {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  },
  getVideoThumbnail(data) {
    var arr = data.split(
      /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/
    );
    var url = arr[5].split("/")[1];
    url = "https://img.youtube.com/vi/" + url + "/default.jpg";
    return url;
  },

  identifyBrowser() {
    // Opera 8.0+
    var isOpera =
      (!!window.opr && !!opr.addons) ||
      !!window.opera ||
      navigator.userAgent.indexOf(" OPR/") >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== "undefined";

    // Safari 3.0+ "[object HTMLElementConstructor]"
    var isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && safari.pushNotification)
      );

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    var isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    return {
      opera: isOpera,
      firefox: isFirefox,
      safari: isSafari,
      ie: isIE,
      edge: isEdge,
      chrome: isChrome
    };
  },

  identifyBrowserMobile() {
    var isMobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      }
    };

    return isMobile;
  },

  getCardType(cardNum) {
    var re = {
      electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
      maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
      dankort: /^(5019)\d+$/,
      interpayment: /^(636)\d+$/,
      unionpay: /^(62|88)\d+$/,
      visa: /^4[0-9]{15}$/,
      mastercard: /^5[1-5][0-9]{14}$/,
      amex: /^3[0-9]{14}$/,
      diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/
    };

    for (var key in re) {
      if (re[key].test(cardNum.replace(/\s/g, ""))) {
        console.log(">>>>>>>>>>", key);
        return key;
      }
    }
  },
  getDisplayImage(type, data, size) {
    let basePath = process.env.VUE_APP_BASE_IMAGE_URL;
    let basePathAlt = process.env.VUE_APP_SERVICE_WORKER_S3;

    switch (type) {
      case "user":
        /**
         * USER AVATAR
         */
        // if( 'avatar_uri' in data ) { // causing error if data has no 'avatar_uri'.
        if (data && data.hasOwnProperty("avatar_uri")) {
          if (data.user_type === "guest") return data.avatar;
          return basePath + size + data.avatar_uri;
        } else if (data && data.avatar && data.avatar.startsWith("avatars/")) {
          if (data.user_type === "guest") return data.avatar;
          return basePath + size + "/" + data.avatar;
        } else {
          // Temporay fix not thumbnail.
          if (data && data.hasOwnProperty("avatar_uri") && data.avatar_uri) {
            return basePathAlt + data.avatar_uri;
          } else {
            if (data && !data.hasOwnProperty("avatar")) return data;

            return data && data.avatar
              ? data.avatar.replace("original", size)
              : null;
          }
        }
        break;
      case "activity_thumbnail":
        /**
         * ACTIVITY thumbnail PHOTO
         */
        if (data && "thumbnail_photo_uri" in data) {
          return basePath + size + data.thumbnail_photo_uri;
        } else if (
          data &&
          data.thumbnail_photo &&
          data.thumbnail_photo.length > 0 &&
          size in data.thumbnail_photo[0]
        ) {
          return data.thumbnail_photo[0][size];
        }
        break;
      case "activity":
        /**
         * ACTIVITY COVER PHOTO
         */
        if (data && "cover_photo_uri" in data) {
          return basePath + size + data.cover_photo_uri;
        } else if (
          data &&
          data.cover_photo &&
          data.cover_photo.length > 0 &&
          size in data.cover_photo[0]
        ) {
          return data.cover_photo[0][size];
        }
        break;
      case "group":
        /**
         * GROUP THUMBNAIL PHOTO
         */
        if (
          data &&
          "thumbnail_photo_uri" in data &&
          data.thumbnail_photo_uri !== null
        ) {
          return basePath + size + data.thumbnail_photo_uri;
        } else if (
          data &&
          data.thumbnail_photo &&
          data.thumbnail_photo.length > 0 &&
          size in data.thumbnail_photo[0]
        ) {
          return data.thumbnail_photo[0][size];
        }
        break;
      case "slideshow":
        /**
         * SLIDESHOW THUMBNAIL PHOTO
         */
        if ("photo_uri" in data) {
          return basePath + size + data.photo_uri;
        } else if ("photo" in data) {
          return data.photo.medium;
        }
    }
  },
  configureMessage() {
    Message.config({
      top: 90,
      duration: 3
    });
  },
  parseDateToMonth(date) {
    return moment(date, "YYYY-MM-DDTHH:mm:Z")
      .format("MMM")
      .toUpperCase();
  },
  parseDateToDay(date) {
    return moment(date, "YYYY-MM-DDTHH:mm:Z")
      .format("DD")
      .toUpperCase();
  },
  parseDateToYear(date) {
    return moment(date, "YYYY-MM-DDTHH:mm:Z")
      .format("YYYY")
      .toUpperCase();
  },
  parseDateToPrettyFormat(date) {
    return moment(date, "YYYY-MM-DDTHH:mm:Z").format("MMMM DD, YYYY");
  },
  parseTimeTo12Hr(time) {
    return moment(time, "HH:mm")
      .format("hh:mma")
      .toUpperCase();
  },
  ifFnExistsCallIt(fnName) {
    fn = window[fnName];
    fnExists = typeof fn === "function";
    if (fnExists) fn();
  },
  getLinkAddress(address) {
    let linkCheck = /(?=<a)(.*?)(?=>)/gm;
    let urlCheck = /(?:href=")(.*?)(?=\")/gm;
    let urlTargetReplace = address.replace(linkCheck, this.targetReplacer);
    let url = urlTargetReplace.replace(urlCheck, this.replacer);
    return url;
  },
  replacer(str, value, offset, s) {
    let getType = /(?=#)(.*?)(?=:)/gm;
    let getValue = /(?=:).*/gm;
    let stringType = value.match(getType);
    let stringValue = value.match(getValue);

    if (!stringType) {
      return str;
    }
    switch (stringType[0]) {
      case "#profile":
        if (location.protocol.includes("https")) {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/profile/" +
            stringValue[0].replace(":", "")
          );
        } else {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/#/profile/" +
            stringValue[0].replace(":", "")
          );
        }
      case "#group":
        if (location.protocol.includes("https")) {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/resources/" +
            stringValue[0].replace(":", "")
          );
        } else {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/#/resources/" +
            stringValue[0].replace(":", "")
          );
        }
      case "#activity":
        if (location.protocol.includes("https")) {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/feed/" +
            stringValue[0].replace(":", "")
          );
        } else {
          return (
            'href="' +
            location.protocol +
            "//" +
            location.host +
            "/#/feed/" +
            stringValue[0].replace(":", "")
          );
        }
      default:
        return str;
    }
  },
  targetReplacer(str, value, offset, s) {
    let urlCheck = /(?:target=")(.*?)(?=\")/gm;
    if (
      value.includes("#profile") ||
      value.includes("#group") ||
      value.includes("#activity")
    ) {
      if (value.includes("target")) {
        return value.replace(urlCheck, 'target="_self" ');
      } else {
        return value.replace("<a ", '<a target="_self" ');
      }
    }
    return value;
  },
  verifyUser() {
    if (store.state.user.info.user_type !== "guest") {
      let isAccountValidated =
        _.filter(store.state.user.info.email, o => {
          return o.validated_at;
        }).length > 0 ||
        _.filter(store.state.user.info.mobile, o => {
          return o.validated_at;
        }).length > 0;

      return isAccountValidated;
    } else return false;
  }
};
